import { render, staticRenderFns } from "./MyFooter2.vue?vue&type=template&id=68cfb2a9&scoped=true&"
import script from "./MyFooter2.vue?vue&type=script&lang=js&"
export * from "./MyFooter2.vue?vue&type=script&lang=js&"
import style0 from "./MyFooter2.vue?vue&type=style&index=0&id=68cfb2a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cfb2a9",
  null
  
)

export default component.exports